<sd-4-5-1-dialog #dialog open="true" [wctSdDialogDestroyComponentAfterClose]="this">
    <table class="sd-table">
      <thead>
        <th class="sd-table-cell sd-table-cell--bg-primary-100">
          {{ 'profile.recertificationsDialog.name' | transloco }}
        </th>

        <th class="sd-table-cell sd-table-cell--bg-primary-100">
          {{ 'profile.recertificationsDialog.funds' | transloco }}
        </th>

        <th class="sd-table-cell sd-table-cell--bg-primary-100">
          {{ 'profile.recertificationsDialog.recertificate' | transloco }}
        </th>
      </thead>

      <tbody [wctApiCallInject]="recertifications" [apiCallAdditionalLoading]="loading">
        @for (recertification of recertifications(); track $index) {
          <tr>
            <td class="sd-table-cell">
              <span>{{ recertification.userInfo.lastName }}, {{ recertification.userInfo.firstName }}</span>
              <br />
              <span>{{ recertification.userInfo.mailAddress }}</span>
            </td>

            <td class="sd-table-cell">
              <span>{{ recertification.fondsName }}</span>
            </td>

            <td class="sd-table-cell">
              <div>
              @if (recertification.active) {
                @if (recertification.pending) {
                  {{ 'profile.recertificationsDialog.yes' | transloco }} ({{
                    'profile.recertificationsDialog.pending' | transloco
                  }})
                } @else {
                  {{ 'profile.recertificationsDialog.active' | transloco }}:
                  {{ 'profile.recertificationsDialog.until' | transloco }} {{ recertification.nextDate | date }}
                }
              } @else {
                {{ 'profile.recertificationsDialog.no' | transloco }}
                @if (recertification.pending) {
                  ({{ 'profile.recertificationsDialog.pending' | transloco }})
                }
              }
              </div>

              @if (!recertification.pending) {
                <sd-4-5-1-radio-group
                  (sd-change)="modify($event, recertification)"
                  [sd-value-injector]="recertificationChange$"
                  name="radio-group"
                  [value]="recertificationChange.noChange"
                  size="sm"
                  form
                  orientation="horizontal">
                  <sd-4-5-1-radio [value]="recertificationChange.noChange" [disabled]="disabled()">
                    {{ 'profile.recertificationsDialog.change.noChange' | transloco }}
                  </sd-4-5-1-radio>

                  <sd-4-5-1-radio [value]="recertificationChange.yes" [disabled]="disabled()">
                    {{ 'profile.recertificationsDialog.change.yes' | transloco }}
                  </sd-4-5-1-radio>

                  <sd-4-5-1-radio [value]="recertificationChange.no" [disabled]="disabled()">
                    {{ 'profile.recertificationsDialog.change.no' | transloco }}
                  </sd-4-5-1-radio>
                </sd-4-5-1-radio-group>
              }
            </td>
          </tr>
        } @empty {
          <div style="height: 76px;"></div>
        }
      </tbody>
    </table>

    <div slot="footer" class="button-row">
      <sd-4-5-1-button
        [loading]="disabled()"
        size="sm"
        variant="cta"
        (click)="save()">
        {{ 'profile.recertificationsDialog.saveText' | transloco }}
      </sd-4-5-1-button>

      <sd-4-5-1-button
        size="sm"
        variant="secondary"
        (click)="dialog.hide()">
        {{ 'general.cancel' | transloco }}
      </sd-4-5-1-button>

      <sd-4-5-1-button
        [disabled]="disabled()"
        size="sm"
        variant="secondary"
        (click)="recertificateAll()">
        {{ 'profile.recertificationsDialog.recertificateAll' | transloco }}
      </sd-4-5-1-button>

      <sd-4-5-1-button
        [disabled]="disabled()"
        size="sm"
        variant="secondary"
        (click)="reset()">
        {{ 'profile.recertificationsDialog.reset' | transloco }}
      </sd-4-5-1-button>
    </div>
</sd-4-5-1-dialog>

